import type { ProductVariantFieldsFragment } from '../../../client/__generated__/graphql-client-types';
import { useRouteSearchParams } from '../routing/params.hook';

/**
 * Hook to update the url when a variant is selected on product pages.
 */
export function useUpdateUrlOnVariantChange() {
	const [queryParams, setQueryParams] = useRouteSearchParams();
	function updateURL(selectedVariant: ProductVariantFieldsFragment) {
		const selectedVariantId = selectedVariant.id.toString();
		if (selectedVariant && queryParams.get('uid') !== selectedVariantId) {
			queryParams.set('uid', selectedVariantId);
			setQueryParams(queryParams, { replace: true });
		}
	}
	return updateURL;
}
